import React from "react";
import ModalContentBaseXl from '../redux/components/modal/modal_content_base_xl';
import ModalAlert from '../redux/components/modal/modal_alert';
import ModalLoader from '../redux/components/modal/modal_loader';
import "babel-polyfill";
import { AiModalBody, AiField, aiInputStyle, AiPrimaryButton, AiResultHeader } from './ai_modal_parts';

export const GenerateOutlineFromTextModal = ({onAcceptEventTitle, onAcceptEventBody}) => {
  const modalRef = React.useRef();
  const errorModalRef = React.useRef();
  const rateLimitModalRef = React.useRef();
  const loaderRef = React.useRef();

  const [theme, setTheme] = React.useState('');
  const [eventTitle, setEventTitle] = React.useState('');
  const [eventBody, setEventBody] = React.useState('');
  // @context TGW-2195 二重送信は「生成中」だけ防ぐ。結果表示後も同じ一言で「作り直す」を押せるようにする（PR #2536 Copilot 指摘）。
  const [isGenerating, setIsGenerating] = React.useState(false);
  // @context TGW-2195 作成前から空の「イベント名」「イベントの説明」欄が並ぶと「ここに入力して」と読まれるため、
  //   AIが作り終わるまで結果欄を出さない（写真から読み取るモーダルと同じ扱い）。
  const [hasResult, setHasResult] = React.useState(false);

  const isValid = theme.length > 0 && !isGenerating;

  const close = () => {
    setTheme('');
    setEventTitle('');
    setEventBody('');
    setHasResult(false);
    modalRef.current && modalRef.current.closeModal();
  };

  const generate = async () => {
    if (isGenerating) return;
    setIsGenerating(true);
    try {
      loaderRef.current.openModal();
      const response = await fetch('/api/event/generate_outline', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ generate: { theme } }),
      });
      if (!response.ok) {
        loaderRef.current.closeModal();
        if (response.status === 429) {
          rateLimitModalRef.current.openModal();
        } else {
          errorModalRef.current.openModal();
        }
        return;
      }

      const json = await response.json();
      setEventTitle(json.result.title || '');
      setEventBody(json.result.body || '');
      setHasResult(true);

      loaderRef.current.closeModal();
    } catch (err) {
      loaderRef.current.closeModal();
      errorModalRef.current.openModal();
    } finally {
      setIsGenerating(false);
    }
  };

  const previewContent = (
    <button
      type="button"
      className="a-button a-button--sm a-button--orange"
      style={{borderRadius: 8}}>一言から作る</button>);
  const modalContent = (
    <div>
      <div
        className="bg-white w-100 border-bottom"
        style={{
          zIndex: 9998,
          borderRadius: '16px 16px 0 0',
          position: 'fixed',
        }}
      >
        <button
          type="button"
          className="close close__modal position--modalclose"
          aria-label="Close"
          onClick={() => close()}
        >
            <span className="text-fz-24px float-right m-2" aria-hidden="true">
              ×
            </span>
        </button>
      </div>
      <AiModalBody
        title="一言から作る"
        description="やりたいことを書くと、AIがイベント名と紹介文を作ります。作った内容は反映する前に直せます。"
      >
        <AiField label="やりたいこと" htmlFor="generate-outline-theme">
          <textarea
            name="theme"
            id="generate-outline-theme"
            className="tg-ai-input"
            style={{ ...aiInputStyle, height: 'auto', resize: 'vertical' }}
            rows={3}
            maxLength={100}
            value={theme}
            onChange={(e) => {
              setTheme(e.target.value)
            }}
            placeholder="例）鎌倉に小旅行に行って食べ歩きしたい"
          ></textarea>
        </AiField>
        <AiPrimaryButton disabled={!isValid} onClick={async () => await generate()}>{hasResult ? '作り直す' : '作る'}</AiPrimaryButton>
        {hasResult &&
          <React.Fragment>
            <AiResultHeader title="作った内容" note="気になるところは、ここで直してから反映してください" />
            <AiField label="イベント名" htmlFor="generated-outline-title">
              <textarea
                id="generated-outline-title"
                className="tg-ai-input"
                style={{ ...aiInputStyle, height: 'auto', resize: 'vertical' }}
                rows={2}
                value={eventTitle}
                onChange={(e) => {
                  setEventTitle(e.target.value)
                }}
              />
            </AiField>
            <AiField label="紹介文" htmlFor="generated-outline-body">
              <textarea
                id="generated-outline-body"
                className="tg-ai-input"
                style={{ ...aiInputStyle, height: 200, overflow: 'auto', whiteSpace: 'pre-wrap', resize: 'vertical' }}
                value={eventBody}
                onChange={(e) => {
                  setEventBody(e.target.value)
                }}
              />
            </AiField>
            <AiPrimaryButton
              onClick={() => {
                onAcceptEventTitle && onAcceptEventTitle(eventTitle)
                onAcceptEventBody && onAcceptEventBody(eventBody);
                alert('イベントに反映しました。');
                close();
              }}
            >この内容を反映する</AiPrimaryButton>
          </React.Fragment>
        }
      </AiModalBody>
    </div>
  );
  return (
    <React.Fragment>
      <ModalContentBaseXl ref={modalRef} previewContent={previewContent} modalContent={modalContent} />
      <ModalAlert
        ref={errorModalRef}
        id="modal-generated-error"
        title="自動生成失敗"
        content="タイトルと説明の自動生成に失敗しました。時間をおいてもう一度お試しください。"
      />
      <ModalAlert
        ref={rateLimitModalRef}
        id="modal-rate-limit-error"
        title="自動生成失敗"
        content="1日の利用数を超過しました。24時間後にもう一度お試しください。"
      />
      <ModalLoader ref={loaderRef} message="約1分お待ちください" dummyProgressShown />
    </React.Fragment>
  );
};
